import {
  Flex,
  Icon,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  UnorderedList,
} from "@chakra-ui/react";
import React from "react";
import { HiExclamationTriangle } from "react-icons/hi2";

import { Button } from "../../../components";
import { PublishWarning } from "./utils";

interface PublishWarningsModalProps {
  isOpen: boolean;
  warnings: PublishWarning[];
  onClose: () => void;
  onPublishAnyway: () => void;
}

const warningMessage = (warning: PublishWarning): string =>
  warning.reason === "missing"
    ? `${warning.label} is not set`
    : `${warning.label} is very short`;

const PublishWarningsModal: React.FC<PublishWarningsModalProps> = ({
  isOpen,
  warnings,
  onClose,
  onPublishAnyway,
}) => (
  <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick size="md">
    <ModalOverlay>
      <ModalContent>
        <ModalHeader>
          <Flex align="center" gap={2}>
            <Icon as={HiExclamationTriangle} color="orange.400" boxSize={5} />
            Publish with warnings?
          </Flex>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb={3}>
            This AI Interviewer can be published, but filling in these optional
            fields will improve interview quality:
          </Text>
          <UnorderedList spacing={1} pl={2}>
            {warnings.map((w) => (
              <ListItem key={w.field} fontSize="sm" color="gray.700">
                {warningMessage(w)}
              </ListItem>
            ))}
          </UnorderedList>
        </ModalBody>
        <ModalFooter justifyContent="space-between">
          <Button variant="ghost" fontWeight="500" onClick={onClose}>
            Keep working
          </Button>
          <Button onClick={onPublishAnyway}>Publish anyway</Button>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  </Modal>
);

export default PublishWarningsModal;
